import React from "react";
import "./skins.css";

function payloadRows(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return [];
  }
  return Object.entries(payload).slice(0, 8);
}

function commandButtons(control) {
  const buttons = control?.payload?.buttons;
  if (Array.isArray(buttons) && buttons.length) {
    return buttons;
  }
  return [{ label: control?.control_type || "실행", cmd: control?.payload || {} }];
}

export default function MonitorCardSkin({
  item,
  latestPayload,
  latestReceivedAt,
  controls = [],
  onControl,
  commandStatus,
}) {
  const values = payloadRows(latestPayload);

  return (
    <section className="monitor-card-skin">
      <header className="monitor-card-skin__header">
        <div>
          <h3>{item?.name || "항목"}</h3>
          <span>{item?.panel_label || item?.category || "미분류"} {item?.device_number || ""}</span>
        </div>
        <strong>{item?.status_label || item?.status || "상태 미지정"}</strong>
      </header>
      <div className="monitor-card-skin__body">
        <div className="monitor-values">
          {!values.length ? (
            <div className="monitor-empty">최근 센서값이 없습니다.</div>
          ) : (
            values.map(([key, value]) => (
              <div className="monitor-value" key={key}>
                <span>{key}</span>
                <strong>{String(value)}</strong>
              </div>
            ))
          )}
        </div>

        <div className="monitor-control-panel">
          <div className="monitor-control-panel__top">
            <strong>제어</strong>
            <span>{latestReceivedAt || "신호 없음"}</span>
          </div>
          {!controls.length ? (
            <div className="monitor-empty">등록된 제어가 없습니다.</div>
          ) : (
            <div className="monitor-controls">
              {controls.map((control, controlIndex) => (
                <div className="monitor-control" key={`${control.sensor_key || "control"}-${controlIndex}`}>
                  <span>{control.sensor_key || `제어 ${controlIndex + 1}`}</span>
                  <div className="monitor-control__buttons">
                    {commandButtons(control).map((button, buttonIndex) => (
                      <button
                        type="button"
                        key={`${button.label || "button"}-${buttonIndex}`}
                        onClick={() => onControl?.(item, controlIndex, buttonIndex)}
                      >
                        {button.label || button.cmd?.cmd || "실행"}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
          {commandStatus ? <div className="monitor-command-status">{commandStatus}</div> : null}
        </div>
      </div>
    </section>
  );
}
